import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/** Wraps any private route. Shows a quiet loader while auth resolves;
 *  redirects to /login (preserving the intended path) when unauthenticated. */
export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-ink-950">
        <div className="mono text-xs text-zinc-500 uppercase tracking-[0.3em] animate-pulse">
          authenticating…
        </div>
      </div>
    );
  }
  if (user === null) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
